import React from "react";
import { Controller, useForm } from "react-hook-form";
import { FormModal } from '@ui-partents/Modal';

import {
  Input,
} from "reactstrap";
import styled from "styled-components";
import { TitleNoteCommon } from "../../../home/generate";

const WrapForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`

const FormDate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

const ModalEdit = ({...props}) => {
  const { toggle, isOpen, handleEdit, seriesDetail } = props
  console.log(seriesDetail);

  //form
  const {
    formState: { errors },
    handleSubmit,
    control
  } = useForm({
    defaultValues: {
      title: seriesDetail?.Name ? seriesDetail?.Name : "",
    }
  });

  const onSubmit = (data) => {
    handleEdit(seriesDetail?.Id, data?.title);
  };

  return (
    <FormModal
      isOpen={isOpen}
      toggleModal={toggle}
      title="Add Series"
      actionText={"Save"}
      maxWidth="750px"
      onAction={handleSubmit(onSubmit)}
    >
      <form className="form-platform">
        <WrapForm>
          <FormDate className='w-100 mb-0'>
            <TitleNoteCommon
              dataFor={'seriesName'} 
              title="Series Name" 
              content=""
              required
            />
            <Controller
              name="title"
              control={control}
              rules={{
                required: "This field is required.",
              }}
              render={({ field }) => (
                <>
                  <Input
                    type='text'
                    name='title'
                    placeholder="Example: Emergency Medicine Modules – Adult & Pediatric"
                    {...field}
                  />
                  {errors.name && <ErrorMessage>{errors.name.message}</ErrorMessage>}
                </>
              )}
            />
          </FormDate>
        </WrapForm>
      </form>
    </FormModal>
  );
};

export default ModalEdit;